import React from 'react';
import PropTypes from 'prop-types';
import { Chip, Box, Typography, useTheme, alpha } from '@mui/material';
import { CheckCircle, Error } from '@mui/icons-material';

const StatusIndicator = React.memo(({ label, status, trueText, falseText }) => {
    const theme = useTheme();
    
    return (
        <Box sx={{ 
            display: 'flex', 
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 2.5,
            borderRadius: 2,
            bgcolor: theme.palette.background.paper,
            boxShadow: `0 4px 20px ${alpha(theme.palette.common.black, 0.08)}`,
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            '&:hover': {
                transform: 'translateY(-3px)',
                boxShadow: `0 8px 30px ${alpha(theme.palette.common.black, 0.12)}`
            },
            position: 'relative',
            overflow: 'hidden',
            '&::after': {
                content: '""',
                position: 'absolute',
                left: 0,
                top: 0,
                width: '4px',
                height: '100%',
                backgroundColor: status ? theme.palette.success.main : theme.palette.error.main,
                transition: 'all 0.3s ease'
            }
        }}>
            <Typography variant="body1" sx={{ 
                fontWeight: 600,
                ml: 1.5,
                color: theme.palette.text.primary 
            }}>
                {label}
            </Typography>
            <Chip
                label={status ? trueText : falseText}
                color={status ? 'success' : 'error'}
                icon={status ? <CheckCircle /> : <Error />}
                sx={{
                    fontWeight: 700,
                    minWidth: 140,
                    fontSize: '0.9rem',
                    py: 0.5,
                    boxShadow: status ? `0 0 12px ${alpha(theme.palette.success.main, 0.4)}` : 
                                                            `0 0 12px ${alpha(theme.palette.error.main, 0.4)}`,
                    '& .MuiChip-icon': {
                        fontSize: '1.2rem',
                    },
                    transition: 'all 0.3s ease'
                }}
            />
        </Box>
    );
});

StatusIndicator.propTypes = {
    label: PropTypes.string.isRequired,
    status: PropTypes.bool.isRequired,
    trueText: PropTypes.string.isRequired,
    falseText: PropTypes.string.isRequired
};

export default StatusIndicator;
